<template>
    <div id="quickFilterSelectorDiv">
        <div class="quickFilterButton" v-for="(qf, index) in quickFilters" :key="index" @click="selectQuickFilter(qf.name)">
            {{ qf.display }}
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            quickFilters() {
                return this.$store.getters.getQuickFilters;
            }
        },
        methods: {
            selectQuickFilter(qfName) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('select', {'event_category': 'quick_filter','event_label': eventLabel});
                this.$store.dispatch('applyQuickFilterSelected', this.quickFilters[qfName]);
                this.$store.commit('updateFilterSelectOpen', '');
            }
        }
    }
</script>

<style>
    #quickFilterSelectorDiv {
        width: calc(84 * var(--vw));
        height: calc(36 * var(--vh));
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }

    .inmobile #quickFilterSelectorDiv {
        height: inherit;
        width: inherit;
    }

    .quickFilterButton {
        width: calc(36 * var(--vw));
        height: calc(8 * var(--vh));
        margin: calc(1 * var(--vh)) calc(1 * var(--vw));
        text-align: center;
        cursor: pointer;
    }

    .inmobile .quickFilterButton {
        width: calc(80 * var(--vw));
    }

    .quickFilterButton:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>